export default "__VITE_ASSET__28dbb740__"